module.exports = __webpack_public_path__ + "static/drift-974ed1621dba490cae33a30f26deeeb0.png";